import { createPublicSiteHandler, } from "../http/site.js";
export * from "../http/index.js";
export function createExpressPublicSiteMiddleware(options) {
    const handler = createPublicSiteHandler({
        ...options,
        acceptsMarkdown: options.acceptsMarkdown ?? ((request) => {
            const expressRequest = request.express;
            return expressRequest?.accepts?.(["html", "text/markdown"]) === "text/markdown";
        }),
    });
    return async (request, response, next) => {
        const requestEvents = request;
        const responseEvents = response;
        const controller = new AbortController();
        const abort = () => controller.abort(new Error("Public site request was aborted."));
        const abortOnClose = () => {
            if (!responseEvents.writableEnded)
                abort();
        };
        requestEvents.once?.("aborted", abort);
        responseEvents.once?.("close", abortOnClose);
        if (requestEvents.aborted)
            abort();
        try {
            const url = request.originalUrl ?? request.url ?? request.path;
            const result = await handler({
                method: request.method,
                pathname: request.path,
                url,
                headers: request.headers,
                signal: controller.signal,
                express: request,
            });
            if (!result) {
                next();
                return;
            }
            response.status(result.statusCode);
            for (const [name, value] of Object.entries(result.headers))
                response.setHeader(name, value);
            if (request.method.toUpperCase() === "HEAD" || result.body.length === 0)
                response.end();
            else
                response.send(result.body);
        }
        catch (error) {
            next(error);
        }
        finally {
            requestEvents.off?.("aborted", abort);
            responseEvents.off?.("close", abortOnClose);
        }
    };
}
//# sourceMappingURL=index.js.map